import { collection, getFirestore } from 'firebase/firestore'
import { app } from './firebase'

export const db = getFirestore(app)
export const inferencesTestRef = collection(db, "InferencesTest")
export const modelsTestRef = collection(db, "ModelsTest")